import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const PageBreak = ({ text, color, fontSize, className }) => {
  return (
    <div className={classNames("page-break", className)} style={{ color: color, fontSize: fontSize }}>
      {text}
    </div>
  );
};

PageBreak.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  fontSize: PropTypes.number,
  className: PropTypes.string,
};

export default PageBreak;
